import styled from 'styled-components';
import TextInput from '../../atoms/TextInput/index';
import {PlusIcon} from '../../atoms/Icons';
import {OnPrimary, PrimaryTextColor} from '../../Colors';

export default {
	Wrapper : styled.div`
		display: flex;
		flex-direction: row;
		min-height: 25px;
        `,
	TextInput : styled(TextInput)`
        flex-grow : 4;
		margin-right : 5px;
		background-color : ${OnPrimary};
		color : ${PrimaryTextColor};
	`,
	PlusIcon
};